import { Modal } from 'react-async-popup';
import { useHistory } from 'react-router-dom';
import { mutate } from 'swr';
// logic
import AlertsList from 'modules/emergencies/components/alerts/AlertsList';
import markAlertsAsRead from 'modules/emergencies/api/markAlertsAsRead';

const useAlertsModal = () => {
  // open modal
  const showAlerts = async () => {
    const { show } = await Modal.new({
      content: <AlertsList />,
      footer: null,
      wrapClassName: 'alerts',
    });
    const result = await show();
    return result;
  };

  const history = useHistory();

  const openModalAlerts = async () => {
    const result = await showAlerts();

    const alertsIDs = (result.alertsToMarkAsRead || []).map((result) => result.id);
    await markAlertsAsRead(alertsIDs);

    mutate((key) => {
      const willMutate =
        key.length === 2 &&
        typeof key[0] === 'string' &&
        key[0].startsWith('price-negotiation/alerts/');
      return willMutate;
    }, undefined);

    if (result.url) history.push(result.url);
    return result;
  };

  const onSubmit = async () => {};

  const onCancel = async () => {};

  return {
    openModalAlerts,
    onSubmit,
    onCancel,
  };
};

export default useAlertsModal;
